{
    "ExcludeheldtimeLabel": "Ne pas tenir compte du temps passé :",
    "TalkTime_SectionHeader": "Temps de parole",
    "TalkTime_SectionPara": "Vous pouvez choisir si les statistiques relatives au temps de conversation de l'appel doivent exclure le temps d'attente de l'appel de la logique de calcul.",
    "NAME": "TalkTime"
}